import type { LogoProps } from '../logo.types';
import bglightgreenLarge from '../../../assets/logos/logo-rd-bglightgreen-large.svg';
import bglightgreenHuge from '../../../assets/logos/logo-rd-bglightgreen-huge.svg';
import bglightgreenEnormous from '../../../assets/logos/logo-rd-bglightgreen-enormous.svg';

const sizeToImage = {
  large: bglightgreenLarge,
  huge: bglightgreenHuge,
  enormous: bglightgreenEnormous,
};

const TITLE = "RdSaude BgLightGreen Logo"

const RdSaudeLightGreen = ({ size, className }: LogoProps) => {
  return (
    <img
      title={TITLE}
      role='img'
      aria-labelledby={TITLE}
      src={sizeToImage[size ?? "large"]}
      alt={TITLE}
      className={className}
    />
  );
};

export default RdSaudeLightGreen; 